import { useEffect, useMemo, useState } from "react";
import { useScoreApi, unwrap } from "../api/scoreApi";
import { useClassesNeedingPlacings } from "./useClassesNeedingPlacings";
import { findJudgesMissingSignature } from "../util/judgeSignatures";

// #3454 -- the judges with no signature on file, for the Station Monitor page
// and its dashboard strip. Reuses the reads Score Admin already makes (class
// list + show rides + ride statuses via useClassesNeedingPlacings, and the
// judge roster Judge Manager reads), so no new API route; the "who is missing"
// answer itself is the pure util/judgeSignatures.js.
//
// A failed or still-loading read yields an EMPTY list, never a banner: an
// unknown roster is not "nobody has signed", and this banner is advisory.
export function useMissingJudgeSignatures(showId) {
  const scoreApi = useScoreApi();
  const { classes, ridesByClassId, loading: classesLoading, error: classesError } = useClassesNeedingPlacings(showId);
  const [judgeState, setJudgeState] = useState({ forShowId: null, judges: null });

  useEffect(() => {
    if (!showId) {
      setJudgeState({ forShowId: null, judges: null });
      return undefined;
    }
    let cancelled = false;
    scoreApi.judges
      .listJudges(showId)
      .then(unwrap)
      .then((judges) => {
        if (!cancelled) setJudgeState({ forShowId: showId, judges });
      })
      .catch(() => {
        if (!cancelled) setJudgeState({ forShowId: showId, judges: null });
      });
    return () => {
      cancelled = true;
    };
  }, [scoreApi, showId]);

  const judges = judgeState.forShowId === showId ? judgeState.judges : null;
  return useMemo(() => {
    if (!showId || classesLoading || classesError || !judges) return [];
    return findJudgesMissingSignature({ classes, judges, ridesByClassId });
  }, [showId, classesLoading, classesError, judges, classes, ridesByClassId]);
}

export default useMissingJudgeSignatures;
